<div class="d-flex">
  <button mat-icon-button class="close-icon ml-auto" (click)="resetIdle()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content class="mat-typography custom-dialog p-3">
  <h1 class="text-center w-100 session-timeout-title">
    Do you want to continue your session?
  </h1>
  <div class="session-timeout-container">
    <div class="sub-header">Your Session will expire in</div>
    <div class="counter-value">
      {{ timer$ | async }}
    </div>
    <mat-progress-spinner
      [color]="'primary'"
      class="t-50"
      [value]="'100'"
      mode="indeterminate">
    </mat-progress-spinner>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="align-items-center justify-content-center pb-3">
  <button mat-stroked-button color="primary" (click)="signout()">
    End Session
  </button>
  <button mat-flat-button color="primary" (click)="resetIdle()">
    Continue Session
  </button>
</mat-dialog-actions>
